<script setup lang="ts">
import VButton from '@components/buttons/VButton/VButton.vue';

import type { VIconButtonEmits, VIconButtonProps } from './types';

withDefaults(defineProps<VIconButtonProps>(), {
  text: true,
});
const emit = defineEmits<VIconButtonEmits>();
</script>

<template>
  <VButton v-data-qa-auto-id="'VIconButton'"
    :size="size"
    :rounded="rounded"
    :text="text"
    :to="to"
    :icon="icon"
    :loading="loading"
    :severity="severity"
    :disabled="disabled"
    :text-color="textColor"
    @click="emit('click', $event)"
  />
</template>
